import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import type { TReminderPerformanceMonth } from '@src/features/reminders/services/reminder-api';

/**
 * Apply the channel mask but keep the API's chronological order.
 * Sorting by month-of-year alone mixes years (Nov 2025 next to Nov 2026).
 */
export function applyChannelMaskToPerformance(
  data: TReminderPerformanceMonth[] | undefined,
  selected: string[]
): TReminderPerformanceMonth[] {
  if (!data?.length) return [];
  if (selected.length === 0) return [...data];
  return data.map((item) => ({
    ...item,
    whatsapp: selected.includes(REMINDER_CHANNELS.whatsapp) ? item.whatsapp : 0,
    email: selected.includes(REMINDER_CHANNELS.email) ? item.email : 0,
    sms: selected.includes(REMINDER_CHANNELS.sms) ? item.sms : 0,
  }));
}
